import * as React from "react";
function SvgGo(props, svgRef) {
  return <svg width={8} height={11} viewBox="0 0 8 11" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}><path d="M0 1.80425C0 1.01881 0.863951 0.539969 1.53 0.956249L7.53 4.70625C7.82238 4.88899 8 5.20946 8 5.55425V5.94575C8 6.29054 7.82238 6.61101 7.53 6.79375L1.53 10.5438C0.86395 10.96 0 10.4812 0 9.69575V1.80425Z" /></svg>;
}
const ForwardRef = React.forwardRef(SvgGo);
export default ForwardRef;